import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Group summary='Validation' mdxType="Group">
      <Item title='valid' subtitle='boolean' label='Required' mdxType="Item">
	Indicates whether the validation was successful or not.
      </Item>
      <Item title='validationErrors' subtitle='InputValidationError[]' label='Required' mdxType="Item">
        <p>{`An array of objects containing information about any input validation errors that occurred during the validation
process.`}</p>
        <Group summary='InputValidationError' mdxType="Group">
          <Item title='name' subtitle='string' label='Required' mdxType="Item">
	The name of the input field that produced the error.
          </Item>
          <Item title='error' subtitle='string' label='Required' mdxType="Item">
            <p>{`The type of error that occurred.`}</p>
            <p>{`Possible values:`}</p>
            <ul>
              <li parentName="ul"><inlineCode parentName="li">{`cardNameRequired`}</inlineCode>{`: cardholder's name is not provided.`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`cardNameContainsNumbers`}</inlineCode>{`: cardholder's name contains numbers.`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`cardNameLength`}</inlineCode>{`: cardholder's name does not match the expected length (minimum: 2, maximum: 45 characters).`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`cardNameContainsInvalidCharacters`}</inlineCode>{`: cardholder's name contains characters that are not supported (only Latin characters are allowed).`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`cardRequired`}</inlineCode>{`: card number is not provided.`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`unsupportedCardType`}</inlineCode>{`: provided card number does not match the allowed card networks.`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`cardIncomplete`}</inlineCode>{`: provided card number does not match the expected length.`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`cardInvalid`}</inlineCode>{`: provided card number is invalid. Additional details might be available in the `}<inlineCode parentName="li">{`message`}</inlineCode>{` field.`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`cvvRequired`}</inlineCode>{`: card's security code (CVV) is not provided.`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`cvvIncomplete`}</inlineCode>{`: card's security code (CVV) does not match the expected length (minimum: 3 characters).`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`cvvInvalid3`}</inlineCode>{`: card's security code (CVV) does not match the expected length (exact: 3 characters).`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`cvvInvalid4`}</inlineCode>{`: card's security code (CVV) does not match the expected length (exact: 4 characters).`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`expiryRequired`}</inlineCode>{`: card's expiry date is not provided.`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`cardExpired`}</inlineCode>{`: card has expired.`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`expiryMonthInvalid`}</inlineCode>{`: expiry date's month is invalid.`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`expiryYearInvalid`}</inlineCode>{`: expiry date's year is invalid.`}</li>
            </ul>
          </Item>
          <Item title='message' subtitle='string' label='Required' mdxType="Item">
	A human-readable message describing the error that occurred.
          </Item>
        </Group>
      </Item>
      <Item title='error' subtitle='string' mdxType="Item">
	A string describing any error that occurred during the validation process.
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      